import { P } from "@antv/g2plot";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { endpoints, getPath } from "./apiUtils";

export const usePublicClasses = () => {
  const path = getPath({
    endpoint: endpoints.classes,
  });

  return useQuery(["public-classes"], async () =>
    axios.get(path).then((r) => r.data)
  );
};

export const useClass = (classId) => {
  const path = getPath({
    endpoint: endpoints.classes,
    path: [classId],
  });

  return useQuery(["class", classId], async () =>
    axios.get(path).then((r) => r.data)
  );
};

export const useClassRequiredItems = (classId) => {
  const path = getPath({
    endpoint: endpoints.classes,
    path: [classId, "requiredItems"],
  });

  return useQuery(["class", classId, "requireditems"], async () =>
    axios.get(path).then((r) => r.data)
  );
};
